module.exports = __webpack_public_path__ + "static/img/slider-7.0f171f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/slider-7.jpg
// module id = hn+b
// module chunks = 7